import './Page.css';

const Page = ({className, children}) => {
  return (
    <div className={`page ${className}`}>{children}</div>
  );
}

export default Page;
